import { Button, Input, Select } from 'antd';
import { Controller } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import Icon from '../Icon/Icon';
import { InvitationType, Props, Role } from './InviteUser.model';
import styles from './InviteUser.module.scss';
import { useInviteUser } from './useInviteUser';

const InviteUser = ({ onClose }: Props) => {
	const {
		control,
		errors,
		handleSubmit,
		i18nCountries,
		sendInvitation,
		state: { invitationType }
	} = useInviteUser({ onClose });

	const { Option } = Select;

	const intl = useIntl();

	return <div className={styles.dropdownContainer}>
		<div className={`${styles.dropdownWrapper} ${styles.topBorder}`}>
			<div className={styles.header}>
				<h1><FormattedMessage id="popupTitles.inviteUser" /></h1>
				<Button onClick={onClose} type="link" className={styles.times}>
					<Icon
						color="text"
						height="16px"
						name="times"
						width="16px"
					/>
				</Button>
			</div>
			<div className={styles.content}>
				<div className={styles.fieldWrapper}>
					<span className={styles.floatingLabel}>
						<FormattedMessage id="formLabels.inviteType" />
					</span>
					<Controller
						control={control}
						name="invitationType"
						render={({ field }) => <Select {...field} className={styles.select}>
							<Option value={InvitationType.Admin}>
								<FormattedMessage id="role.Admin" />
							</Option>
							<Option value={InvitationType.User}>
								<FormattedMessage id="role.User" />
							</Option>
						</Select>}
					/>
				</div>
				{invitationType === InvitationType.User && <div className={`${styles.fieldWrapper} ${errors.role ? styles.error : ''}`}>
					<span className={styles.floatingLabel}>
						<FormattedMessage id="userLabels.role" />
					</span>
					<Controller
						control={control}
						name="role"
						rules={{ required: true }}
						render={({ field }) =>
							<Select {...field} className={styles.select}>
								<Option value={Role.Mentor}>
									<FormattedMessage id="role.Mentor" />
								</Option>
								<Option value={Role.Mentee}>
									<FormattedMessage id="role.Mentee" />
								</Option>
								<Option value={Role.ApplicantMentee}>
									<FormattedMessage id="role.ApplicantMentee" />
								</Option>
							</Select>
						}
					/>
				</div>}
				<div className={`${styles.fieldWrapper} ${errors.firstName ? styles.error : ''}`}>
					<span className={styles.floatingLabel}>
						<FormattedMessage id="formLabels.firstName" />
					</span>
					<Controller
						control={control}
						name="firstName"
						rules={{ required: true }}
						render={({ field }) => <Input {...field} placeholder={intl.formatMessage({ id: "formPlaceholders.firstName" })} />}
					/>
				</div>
				<div className={`${styles.fieldWrapper} ${errors.lastName ? styles.error : ''}`}>
					<span className={styles.floatingLabel}>
						<FormattedMessage id="formLabels.lastName" />
					</span>
					<Controller
						control={control}
						name="lastName"
						rules={{ required: true }}
						render={({ field }) => <Input {...field} placeholder={intl.formatMessage({ id: "formPlaceholders.lastName" })} />}
					/>
				</div>
				<div className={`${styles.fieldWrapper} ${errors.email ? styles.error : ''}`}>
					<span className={styles.floatingLabel}>
						<FormattedMessage id="formLabels.email" />
					</span>
					<Controller
						control={control}
						name="email"
						rules={{ required: true }}
						render={({ field }) => <Input {...field} placeholder={intl.formatMessage({ id: "formPlaceholders.email" })} />}
					/>
				</div>
				<div className={`${styles.fieldWrapper} ${errors.location ? styles.error : ''}`}>
					<span className={styles.floatingLabel}>
						<FormattedMessage id="userLabels.location" />
					</span>
					<Controller
						control={control}
						name="location"
						rules={{ required: true }}
						render={({ field }) =>
							<Select
								className={styles.select}
								{...field}
								filterOption={(input, option: any) =>
									option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
								placeholder={intl.formatMessage({ id: 'formPlaceholders.location' })}
								showArrow={false}
								showSearch={true}
							>
								{Object.keys(i18nCountries).map(code => (
									<Option key={code} value={code}>{i18nCountries[code]}</Option>
								))}
							</Select>
						}
					/>
				</div>
			</div>
			<div className={styles.actions}>
				<Button type="default" onClick={onClose} size="large">
					<FormattedMessage id="buttons.cancel" />
				</Button>
				<Button type="primary" onClick={handleSubmit(sendInvitation)} size="large">
					<FormattedMessage id="buttons.sendInvitation" />
				</Button>
			</div>
		</div>
	</div>
}
export default InviteUser;